export function csrfToken() {
  return document.querySelector("[name='csrf-token']")?.content || '';
}

export function localTime() {
  return new Date().toString();
}
